import { render, staticRenderFns } from "./AssetCrud.vue?vue&type=template&id=e51ad972&scoped=true"
import script from "./AssetCrud.vue?vue&type=script&lang=js"
export * from "./AssetCrud.vue?vue&type=script&lang=js"
import style0 from "./AssetCrud.vue?vue&type=style&index=0&id=e51ad972&prod&lang=scss&scoped=true"
import style1 from "./AssetCrud.vue?vue&type=style&index=1&id=e51ad972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51ad972",
  null
  
)

export default component.exports